<template>
  <SimpleLink
    v-if="isClickable"
    :to="productUrl"
    tag="button"
    class="relative flex flex-shrink-0 self-start w-16 h-16"
  >
    <TwicpicsImage
      :src="image"
      :alt="imageAlt"
      class="object-contain"
      :height="VERTICAL_PRODUCT_CARD.IMAGE_HEIGHT"
      :width="VERTICAL_PRODUCT_CARD.IMAGE_WIDTH"
    />
  </SimpleLink>
  <div
    v-else
    class="relative flex flex-shrink-0 self-start w-16 h-16"
  >
    <TwicpicsImage
      :src="image"
      :alt="imageAlt"
      class="object-contain"
      :height="VERTICAL_PRODUCT_CARD.IMAGE_HEIGHT"
      :width="VERTICAL_PRODUCT_CARD.IMAGE_WIDTH"
    />
  </div>
</template>

<script lang="ts">

import { VERTICAL_PRODUCT_CARD } from '~~/constants/productCard';
import { addNativeRoutingToProductUrl } from '~~/helpers/routes/nativeRouting/transformProductsForNativeRouting';

export default defineComponent({
  name: 'ProductCardVerticalImage',

  props: {
    image: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    isClickable: {
      type: Boolean,
      default: true,
    },
  },
  setup(props) {

    const { countryCode } = useLocalization();
    const i18n = useI18n();

    const productUrl = computed(() => {

      return props.link !== '' ? addNativeRoutingToProductUrl(props.link, countryCode.value) : props.link;
    
    });
    const imageAlt = computed(() => {

      return `${props.title} - ${i18n.t('Product Image')}`;
    
    });

    return {
      productUrl,
      VERTICAL_PRODUCT_CARD,
      imageAlt,
    };
  
  },
});

</script>
